/**
 * Conexão "Apenas receptiva" não entra no disparo de campanhas (não lista no UI).
 * @param {object} w - registo retornado por GET /whatsapp
 * @returns {boolean}
 */
export const isWhatsappEligibleForCampaigns = (w) => Boolean(w && w.inboundOnly !== true);

export const filterWhatsappListForCampaigns = (whatsapps) =>
  (whatsapps || []).filter(isWhatsappEligibleForCampaigns);

/** Baileys e Meow (WuzAPI / WhatsMeow) — únicos canais válidos para Campanha PRO. */
const CAMPAIGN_PRO_CHANNELS = new Set(["whatsapp", "wuzapi", "whatsmeow"]);

const normalizeChannel = (channel) =>
  String(channel || "whatsapp").toLowerCase().trim();

/**
 * Campanha PRO: só Baileys / Meow — exclui WebChat, Oficial, Telegram, etc.
 * @param {object} w - registo retornado por GET /whatsapp
 * @returns {boolean}
 */
export const isWhatsappEligibleForCampaignPro = (w) => {
  if (!isWhatsappEligibleForCampaigns(w)) return false;
  if (!CAMPAIGN_PRO_CHANNELS.has(normalizeChannel(w.channel))) return false;
  if (w.waba_id || w.phone_number_id) return false;
  if (w.type === "facebook" || w.type === "instagram") return false;
  if (w.channel === "facebook" || w.channel === "instagram") return false;
  return true;
};

export const filterWhatsappListForCampaignPro = (whatsapps) =>
  (whatsapps || []).filter(isWhatsappEligibleForCampaignPro);
